/**
 * @ngdoc       provider
 * @name        PurchaseOrdersServicec
 * @module      csm.books.PurchaseOrders
 * @description
 * Provides configuration of the PurchaseOrdersService.
 */
/* @ngInject */ export function PurchaseOrdersServiceProvider() {
  this.httpServiceBase = '/books/purchaseOrders/';
  this.httpServices = {
    bulkClosePurchaseOrders: function (ids) {
      return this.post('bulkClosePurchaseOrders', { ids });
    },
    findAddressVendors: function (name, activeOnly, entityID) {
      return this.post('findAddressVendors', {
        name: name,
        activeOnly: activeOnly,
        entityID: entityID
      });
    },
    findPurchaseOrders: function (filters) {
      return this.post('findPurchaseOrders', filters);
    },
    getNextNumber: function () {
      return this.get('getNextNumber');
    },
    getAccountsAndProducts: function () {
      return this.get('getAccountsAndProducts');
    },
    getPurchaseOrder: function (id, directionIndicator) {
      return this.get(
        'getPurchaseOrder/{0}/{1}'.format(id || 0, directionIndicator || 0)
      );
    },
    savePurchaseOrder: function (purchaseOrder) {
      return this.post('savePurchaseOrder', purchaseOrder);
    }
  };

  this.$get = ['HTTPService', function (HTTPService) {
    return Object.assign(
      HTTPService.make(this.httpServiceBase),
      this.httpServices
    );
  }];
};

PurchaseOrdersServiceProvider.$inject = [];